var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","width":_vm.width,"height":_vm.height}},[_c('g',{attrs:{"fill":_vm._secondaryfill}},[_c('path',{attrs:{"d":"M13,5.6A7.5,7.5,0,0,1,5.6,13,5.5,5.5,0,1,0,13,5.6Z"}}),_c('circle',{attrs:{"cx":"5.5","cy":"5.5","r":"5.5","fill":_vm.fill}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }